import { UserEdition } from "@encoo-web/encoo-lib/types";
import {
  EnterpriseAccountCreateData,
  EnterpriseUpdate,
} from "src/models/company";
import { companyServiceHttpClient } from "../common/CompanyServiceHttpClient";

export class CompanyAccountSeviceClient {
  async list(
    Name?: string,
    Edition?: UserEdition,
    Limit?: number,
    LastRowKey?: string
  ) {
    return await companyServiceHttpClient.get("/v2/CompanyAdmin/companies", {
      params: {
        Name: Name,
        Edition: Edition,
        Limit: Limit,
        LastRowKey: LastRowKey,
      },
    });
  }

  async create(payload: EnterpriseAccountCreateData) {
    return await companyServiceHttpClient.post(
      "/v2/CompanyAdmin/companies/register",
      payload,
      {}
    );
  }

  async update(payload: {
    id: string;
    enterpriseData: Partial<EnterpriseUpdate>;
  }) {
    const { id, enterpriseData } = payload;
    return await companyServiceHttpClient.patch(
      `/v2/CompanyAdmin/companies/${id}`,
      enterpriseData,
      {}
    );
  }

  async getDetail(id: string) {
    return await companyServiceHttpClient.get(
      `/v2/CompanyAdmin/companies/${id}`,
      {}
    );
  }

  async activateLicense(argCompanyId: string, license: string) {
    return await companyServiceHttpClient.post(
      `/v2/licenseV2Admin/${argCompanyId}`,
      JSON.stringify(license),
      {}
    );
  }

  async licenseDetail(argCompanyId: string) {
    return await companyServiceHttpClient.get(
      `/v2/licenseV2Admin/${argCompanyId}`,
      {}
    );
  }
}
export const AccountSeviceClient = new CompanyAccountSeviceClient();
